import { withRouter, Link } from "react-router-dom"
import React, { useState } from "react"
import {
  Card,
  Button,
  CardBody,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import moment from "moment";
import TableLoader from "components/Common/TableLoader"

function Table(props) {

  const { data } = props
  // console.log(data)
  const columns = [
    {
      dataField: "day",
      text: "Day Of Month",
      sort: true,
    },
    {
      dataField: "unique_deposit",
      text: "Unique Deposit Players",
      sort: true,
      formatter: (cell, row) => <>{Number(row.unique_deposit).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "unique_withdraw",
      text: "Unique Withdraw Players",
      sort: true,
      formatter: (cell, row) => <>{Number(row.unique_withdraw).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "deposit",
      text: "Deposits",
      sort: true,
      formatter: (cell, row) => <>{Number(row.deposit).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "withdraw",
      text: "Withdrawals",
      sort: true,
      formatter: (cell, row) => <>{Number(row.withdraw).toLocaleString('en-GB')}</>,
    },
  ]
  const defaultSorted = [
    {
      dataField: "day",
      order: "asc",
    },
  ]

  const { SearchBar } = Search
  //pagination customization

  const pageOptions = {
    sizePerPage: data?.length,
    totalSize: data?.length,
    custom: true,
  }

  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"MIMO Report"}</div>
          {props.loadingMessage && props.loadingMessage == "1" ? (
            <TableLoader />
          ) : (
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField="id"
              columns={columns}
              data={data}
            >
              {({ paginationProps, paginationTableProps }) => (
                <ToolkitProvider
                  keyField="id"
                  data={data}
                  columns={columns}
                  bootstrap4
                  search
                >
                  {toolkitProps => (
                    <React.Fragment>
                      <Row className="mb-2">
                        <Col sm="6">
                          <Row>
                            <Col sm="6">
                              <div className="search-box me-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                  <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div>
                                <ReactHTMLTableToExcel
                                    id="test-table-xls-button"
                                    className="download-table-xls-button w-md btn btn-primary"
                                    table="table-to-xls"
                                    filename={`Mimo-Report-${moment(new Date()).format("DD/MM/YYYY")}`}
                                    sheet="tablexls"
                                    buttonText="Download"
                                    type="button"
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col sm={6}></Col>
                      </Row>
                      <Row>
                        <Col xl="12">
                          <div className="table-responsive">
                            <BootstrapTable id="table-to-xls"
                              keyField="id"
                              responsive
                              bordered={false}
                              striped={false}
                              defaultSorted={defaultSorted}
                              //   selectRow={selectRow}
                              classes={
                                "table align-middle table-nowrap table-check"
                              }
                              headerWrapperClasses={"table-light"}
                              {...toolkitProps.baseProps}
                              {...paginationTableProps}
                              rowClasses={"mytable-hover-row"}
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="pagination pagination-rounded justify-content-end">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          )}
        </CardBody>
      </Card>
    </>
  )
}

export default Table
